// ABOUTME: Scrolls to top on route changes
// ABOUTME: Placed inside the Router to react to navigation events

import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ScrollToTop() {
  const location = useLocation()

  // biome-ignore lint/correctness/useExhaustiveDependencies: scroll must fire on every route change
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  return null
}
